// Assets are served from this site's own /uploads folder.
export const getAssetUrl = (path: string = "") => path;
